(ns ui.components.input.phone
  (:require
   [common.util :as cu]
   [frontend.utils :as fu]
   [oops.core :as oops]
   [reagent.core :as r]))

(defn view
  [{:keys [_value _placeholder _class _disabled? _on-change _transparent? _on-focus _on-blur _on-key-down _variant]}]
  (let [local-state (r/atom {})]
    (fn [{:keys [ref _dom-id class _custom-class placeholder value auto-focus? variant disabled? _read-only? transparent? _full-width? on-change on-focus on-blur on-key-down _label]}]
      (let [{:keys [selection-start selection-end]} @local-state]
        [:input
         (merge {:ref         (fn [input-ref]
                                (when input-ref
                                  (when (:focused? @local-state)
                                    (oops/ocall input-ref "setSelectionRange" selection-start selection-end))
                                  (when-not (:initialized? @local-state)
                                    (swap! local-state assoc :initialized? true)
                                    (when auto-focus?
                                      (oops/ocall input-ref "focus"))
                                    (when (fn? ref)
                                      (ref input-ref)))))
                 :class-name  (fu/cs "peer px-3 text-md rounded placeholder-transparent focus:outline-none focus:ring-0 "
                                     (if (not= variant :borderless)
                                       "py-2 border border-input-light-border-paler hover:border-input-light-border focus:border-input-light-border"
                                       "py-2 border-none focus:border-transparent ")
                                     (if transparent?
                                       "bg-transparent disabled:bg-transparent"
                                       "text-input-light-text disabled:text-disabled-light-text
                                        bg-input-light disabled:bg-disabled-light")
                                     (when-not (cu/blank-value? value)
                                       "value")
                                     class)
                 :value       (or value "")
                 :placeholder (or placeholder "")
                 :type        "tel"
                 :on-focus    (fn [_e]
                                (swap! local-state assoc :focused? true)
                                (when (fn? on-focus)
                                  (on-focus)))
                 :on-blur     (fn [e]
                                (when (fn? on-blur)
                                  (on-blur (->> e
                                                .-target
                                                .-value))))
                 :on-key-down (fn [e]
                                (when (fn? on-key-down)
                                  (on-key-down e)))
                 :on-change   (fn [e]
                                (let [value (->> e .-target .-value)]
                                  (swap! local-state assoc
                                         :selection-start (-> e .-target .-selectionStart)
                                         :selection-end (-> e .-target .-selectionEnd))
                                  (cond (fn? on-change)
                                        (on-change value)
                                        :else
                                        (swap! local-state assoc :temp-value value))))}
                (when disabled?
                  {:disabled true}))]))))
